import { addLabelName, labelColor, labelSuggestions } from '../../lib/event-labels.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- event-label-picker ---
let __fez_component_0;
{

__fez_component_0 = class {
  PROPS = {
    event: String,
    calendar: String,
    labels: { type: Array, default: [] },
    on_change: { type: Function, state: true, default: () => {} },
  }

  init() {
    this.state.mine = []
    this.state.text = ''
    this.state.open = false
    this.state.active = -1
    this.state.shown = null
    this.state.error = ''
    this.state.seq = 0
  }

  onMount() {
    this.loadMine()
  }

  async loadMine() {
    try {
      this.state.mine = (await window.App.api('calendar/labels', {}, { silent: true })).items
    } catch (error) {
      this.state.error = error.message
    }
  }

  names() {
    return this.state.shown || this.props.labels
  }

  // Shown at once; the last answer wins when changes overlap.
  async save(names) {
    const seq = ++this.state.seq
    this.state.shown = names
    try {
      const view = await window.App.api('calendar/event_labels', { event: this.props.event, calendar: this.props.calendar || undefined, labels: names }, { silent: true })
      if (seq !== this.state.seq) return
      this.state.error = ''
      this.state.on_change(view)
      if (view.labels.some((name) => !this.state.mine.some((entry) => entry.name.toLowerCase() === name.toLowerCase()))) this.loadMine()
      window.Fez.publish('labels:change')
    } catch (error) {
      if (seq === this.state.seq) this.state.error = error.details?.labels || error.details?.name || error.message
    } finally {
      if (seq === this.state.seq) this.state.shown = null
    }
  }

  add(name) {
    const names = addLabelName(this.names(), this.state.mine, name)
    this.clear()
    if (names) this.save(names)
  }

  // The field keeps what was typed while it has the focus, so it is emptied by hand.
  clear() {
    this.typed('')
    const input = this.find('.tp-input')
    if (input) input.value = ''
  }

  pick(index) {
    const label = this.state.suggestions[index]
    if (label) this.add(label.name)
  }

  remove(index) {
    this.save(this.names().filter((_, at) => at !== index))
  }

  typed(value) {
    this.state.text = value
    this.state.active = -1
  }

  focused(on) {
    this.state.open = on
    if (!on) this.state.active = -1
  }

  key(event) {
    const count = this.state.suggestions.length
    if (event.key === 'Enter') {
      event.preventDefault()
      if (this.state.active >= 0) this.pick(this.state.active)
      else this.add(event.target.value)
    } else if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && count) {
      event.preventDefault()
      const active = this.state.active
      if (event.key === 'ArrowDown') this.state.active = active < 0 ? 0 : (active + 1) % count
      else this.state.active = active < 0 ? count - 1 : (active - 1 + count) % count
    } else if (event.key === 'Backspace' && !event.target.value && this.names().length) {
      this.remove(this.names().length - 1)
    } else if (event.key === 'Escape' && event.target.value) {
      event.preventDefault()
      event.stopPropagation()
      this.clear()
    }
  }

  beforeRender() {
    const names = this.names()
    this.state.chips = names.map((name) => ({ name, color: labelColor(name) }))
    this.state.suggestions = labelSuggestions(this.state.mine, names, this.state.text).map((label) => ({ name: label.name, color: labelColor(label.name) }))
    const text = this.state.text.trim().toLowerCase()
    this.state.fresh = Boolean(text) && ![...this.state.mine.map((label) => label.name), ...names].some((name) => name.toLowerCase() === text)
    this.state.menu = this.state.open && (this.state.suggestions.length > 0 || this.state.fresh)
  }

  CSS = `:fez {
display:block;.tp{display:grid;gap:var(--space-2)}.tp-list{display:flex;flex-wrap:wrap;align-items:center;gap:var(--space-2)}.tp-chip,.tp-option{display:inline-flex;align-items:center;gap:var(--space-2);max-width:100%;height:30px;border-radius:var(--radius-full);color:var(--color-text);font-size:var(--text-sm);font-weight:var(--weight-medium)}.tp-chip{padding:0 var(--space-1) 0 var(--space-3);background:color-mix(in srgb,var(--tag,var(--color-border-strong)) 16%,var(--color-bg-raised))}.tp-dot{width:8px;height:8px;flex:none;border-radius:var(--radius-full);background:var(--tag,var(--color-border-strong))}.tp-name{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.tp-remove{display:inline-grid;flex:none;place-items:center;width:22px;height:22px;padding:0;border:0;border-radius:var(--radius-full);background:transparent;color:var(--color-text-muted);cursor:pointer;&:hover{background:var(--color-bg-hover);color:var(--color-text)}&:focus-visible{outline:2px solid var(--color-focus);outline-offset:1px}}.tp-input{flex:1;min-width:140px;height:30px;padding:0 var(--space-3);border:1px dashed var(--color-border-strong);border-radius:var(--radius-full);background:transparent;color:var(--color-text);font:inherit;font-size:var(--text-sm);&::placeholder{color:var(--color-text-subtle)}&:focus{border-style:solid;border-color:var(--color-accent);outline:2px solid var(--color-focus);outline-offset:-1px}}.tp-menu{display:flex;flex-wrap:wrap;align-items:center;gap:var(--space-2)}.tp-option{padding:0 var(--space-3);border:1px solid var(--color-border);background:var(--color-bg-raised);font:inherit;font-size:var(--text-sm);cursor:pointer;&:hover,&.active{border-color:var(--tag);background:color-mix(in srgb,var(--tag) 12%,var(--color-bg-raised))}}.tp-hint,.tp-error{color:var(--color-text-muted);font-size:var(--text-xs)}.tp-error{color:var(--color-danger)}
}`

  HTML = `<div class="tp">
<div class="tp-list">
{#each state.chips as chip}
<span class="tp-chip" key={chip.name} style="--tag: var(--color-avatar-{chip.color})">
<span class="tp-dot"></span>
<span class="tp-name">{chip.name}</span>
<button class="tp-remove" type="button" title="Remove" aria-label="Remove {chip.name}" onclick="fez.remove({i})"><ui-icon name="x" size="12"></ui-icon></button>
</span>
{/each}
<input class="tp-input" type="text" value={state.text} placeholder={state.chips.length ? 'Add a label' : 'Add a label: work, a client, deep work'} maxlength="60" autocomplete="off" aria-label="Add a label" oninput="fez.typed(this.value)" onkeydown="fez.key(event)" onfocus="fez.focused(true)" onblur="fez.focused(false)">
</div>
{#if state.menu}
<div class="tp-menu" role="listbox" aria-label="Your labels">
{#each state.suggestions as label}
<button type="button" class="tp-option" class:active={i === state.active} key={label.name} role="option" aria-selected={i === state.active ? 'true' : 'false'} style="--tag: var(--color-avatar-{label.color})" onmousedown="event.preventDefault()" onclick="fez.pick({i})"><span class="tp-dot"></span><span class="tp-name">{label.name}</span></button>
{/each}
{#if state.fresh}<span class="tp-hint">Enter adds the new label "{state.text.trim()}"</span>{/if}
</div>
{/if}
{#if state.error}<span class="tp-error" role="alert">{state.error}</span>{/if}
</div>`
};
}

Fez('event-label-picker', __fez_component_0);

export default __fez_component_0;
